import init from './_init.js';
import auth from './_auth.js';
const _actions = {
  init,
  auth
};
export default _actions;
